import * as React from 'react';

function SvgMagnetOutlined(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" className="MagnetOutlined_svg__icon" viewBox="0 0 1024 1024" {...props}>
      <path d="M959.568 60.91V31.949C959.568 14.297 945.27 0 927.619 0H703.356c-17.652 0-31.949 14.297-31.949 31.949v130.446c0 .048.032.095.032.143V559.42c0 96.165-54.248 174.375-150.414 174.375S352.64 655.585 352.64 559.42V60.91h-.095V31.949C352.545 14.297 338.248 0 320.596 0H96.333C78.681 0 64.384 14.297 64.384 31.949v130.446c0 .655.336 1.198.368 1.837v409.836C64.752 822.58 263.216 1024 511.696 1024s447.936-201.42 447.936-449.932V60.91h-.064zm-63.897 2.987v128.13H735.672V63.897h159.999zm-607.024 0v128.13H128.65V63.897h159.998zM511.681 960.12c-212.874 0-383.048-173.193-383.048-386.035v-318.16h160.078V559.42c0 131.596 100.686 238.272 232.283 238.272S735.32 691.016 735.32 559.42V255.924h160.397v318.16c0 212.842-171.148 386.035-384.037 386.035z" />
    </svg>
  );
}

export default SvgMagnetOutlined;
